import { Chip, Flex } from '@servicetitan/anvil2';
import { ProviderLogo } from '@servicetitan/financing-provider-assets';

export interface ProviderAndLogoProps {
    provider: string | null | undefined;
    showPreferredProviderChip?: boolean;
}

export const ProviderAndLogo = ({ provider, showPreferredProviderChip }: ProviderAndLogoProps) => {
    if (!provider) {
        return null;
    }

    return (
        <>
            <Flex alignItems="center" gap="1">
                {provider}
                {showPreferredProviderChip && <Chip label="Preferred" />}
            </Flex>
            <ProviderLogo provider={provider} />
        </>
    );
};
